import Vue from 'vue'
import Index from '@/views/index'
import Home from '@/views/home'

const AboutUs = r => require.ensure([], () => r(require('@/views/aboutUs')), 'aboutUs')
const PlatformIntroduce = r => require.ensure([], () => r(require('@/views/platformIntroduce')), 'PlatformIntroduce')
const ContactUs = r => require.ensure([], () => r(require('@/views/contactUs')), 'contactUs')
const MediaReport = r => require.ensure([], () => r(require('@/views/mediaReport')), 'mediaReport')
const ComponeyNotice = r => require.ensure([], () => r(require('@/views/componeyNotice')), 'componeyNotice')
const News = r => require.ensure([], () => r(require('@/views/news')), 'news')
const CityCompany = r => require.ensure([], () => r(require('@/views/cityCompany')), 'cityCompany')
const OperationTraining = r => require.ensure([], () => r(require('@/views/operationTraining')), 'operationTraining')
const ReturnRecharge = r => require.ensure([], () => r(require('@/views/returnRecharge')), 'returnRecharge')
const AddedService = r => require.ensure([], () => r(require('@/views/addedService')), 'addedService')
const ArticleList = r => require.ensure([], () => r(require('@/views/articleList')), 'articleList')

const searchResult = r => require.ensure([], () => r(require('@/views/searchResult')), 'searchResult')  //排名查询结果
const searchResultList = r => require.ensure([], () => r(require('@/views/searchResultList')), 'searchResultList')  //排名查询结果列表
const searchResultBatch = r => require.ensure([], () => r(require('@/views/searchResultBatch')), 'searchResultBatch') //批量查询结果
const searchResultBatchList = r => require.ensure([], () => r(require('@/views/searchResultBatchList')), 'searchResultBatchList') //批量查询结果
const searchSEOResult = r => require.ensure([], () => r(require('@/views/searchSEOResult')), 'searchSEOResult') //SEO优化查询结果
const searchCaseResult = r => require.ensure([], () => r(require('@/views/searchCaseResult')), 'searchCaseResult')  //案例查询结果

// 后台
const Dashboard = r => require.ensure([], () => r(require('@/views/dashboard/dashboard')), 'dashboard') // 后台首页
const Board = r => require.ensure([], () => r(require('@/views/dashboard/board')), 'board') // 后台首页

//账户管理
const AccountManagement = r => require.ensure([], () => r(require('@/views/dashboard/accountManagement/index')), 'accountManagement') // 账户管理
const PersonalInfo = r => require.ensure([], () => r(require('@/views/dashboard/accountManagement/personalInfo')), 'personalInfo')    // 个人信息
const Notice = r => require.ensure([], () => r(require('@/views/dashboard/accountManagement/notice')), 'notice')                      // 消息通知
const AuthenctionCenter = r => require.ensure([], () => r(require('@/views/dashboard/accountManagement/authenctionCenter')), 'authenctionCenter') // 认证中心
const AuthenctionCenterDetail = r => require.ensure([], () => r(require('@/views/dashboard/accountManagement/authenctionCenterDetail')), 'authenctionCenterDetail') // 认证中心
const ChangePassword = r => require.ensure([], () => r(require('@/views/dashboard/accountManagement/changePassword')), 'changePassword') // 修改密码

// 财务管理
const CaiwuManagement = r => require.ensure([], () => r(require('@/views/dashboard/caiwuManagement/index')), 'caiwuManagement') // 财务管理
const Recharge = r => require.ensure([], () => r(require('@/views/dashboard/caiwuManagement/recharge')), 'recharge')            // 充值
const Deposit = r => require.ensure([], () => r(require('@/views/dashboard/caiwuManagement/deposit')), 'deposit')               // 提现
const Record = r => require.ensure([], () => r(require('@/views/dashboard/caiwuManagement/record')), 'record')                  // 消费记录

//优化管理
const OptimizeManagement = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/index')), 'optimizeManagement') // 优化管理
const IntegrationOptimize = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/integrationOptimize')), 'integrationOptimize') // 积分优化
const IntegrationOptimizeResult = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/integrationOptimizeResult')), 'integrationOptimizeResult') // 积分优化结果
const QuickRanking = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/quickRanking')), 'quickRanking')       // 快速排名
const QuickRankingDetail = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/quickRankingDetail')), 'quickRankingDetail')       // 快速排名
const QuickRankingNoData = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/quickRankingNoData')), 'quickRankingNoData')       // 快速排名
const SEOOptimize = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/SEOOptimize')), 'SEOOptimize')          // SEO优化
const SEOOptimizeDetail = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/SEOOptimizeDetail')), 'SEOOptimizeDetail')          // SEO优化
const WebOptimize = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/webOptimize')), 'webOptimize')          // 整站优化
const KeywordManagement = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/keywordManagement')), 'keywordManagement')  // 关键词管理
const keywordManagementDetail = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/keywordManagementDetail')), 'keywordManagement')  // 关键词管理
const ShoppingCar = r => require.ensure([], () => r(require('@/views/dashboard/optimizeManagement/shoppingCar')), 'shoppingCar')          // 购物车

// 共犯管理
const OrderManagement = r => require.ensure([], () => r(require('@/views/dashboard/orderManagement/index')), 'orderManagement') // 工单管理
const OrderManagementDetail = r => require.ensure([], () => r(require('@/views/dashboard/orderManagement/orderManagementDetail')), 'OrderManagementDetail') // 工单管理
const SubmitOrder = r => require.ensure([], () => r(require('@/views/dashboard/orderManagement/submitOrder')), 'submitOrder') // 工单管理


const AddService = r => require.ensure([], () => r(require('@/views/dashboard/addService')), 'addService') // 增值服务
const PreviewVideo = r => require.ensure([], () => r(require('@/views/dashboard/previewVideo')), 'previewVideo') // 增值服务
const Apply = r => require.ensure([], () => r(require('@/views/dashboard/apply')), 'apply') // 代理申请
const Reward = r => require.ensure([], () => r(require('@/views/dashboard/reward')), 'reward') // 邀请奖励
const Exit = r => require.ensure([], () => r(require('@/views/dashboard/exit')), 'exit') // 退出

const G2Circle = r => require.ensure([], () => r(require('@/components/G2Circle')), 'G2Circle')

export default[
  // {
  //   path: '/',
  //   redirect: 'index'
  // },
    {
    path: '/',
 //   redirect: '/index/home',
    component: Index,
    children: [
      {
        path: '/',
        component: Home
      }, {
        path: '/index/result',
        redirect: '/index/result/list',
        component: searchResult,
        children: [
          {
            path: '/index/result/list',
            component: searchResultList
          }, {
            path: '/index/result/batch',
            component: searchResultBatch
          },{
            path: '/index/result/batchlist',
            component: searchResultBatchList
          }, {
            path: '/index/result/seo',
            component: searchSEOResult
          }, {
            path: '/index/result/case/:word?',
            component: searchCaseResult
          }
        ]
      },{
        path: '/index/aboutUs',
        component: AboutUs
      },{
        path: '/index/platformIntroduce',
        component: PlatformIntroduce
      },{
        path: '/index/contactUs',
        component: ContactUs
      },{
        path: '/index/mediaReport',
        component: MediaReport
      },{
        path: '/index/componeyNotice',
        component: ComponeyNotice
      },{
        path: '/index/news',
        component: News
      },{
        path: '/index/cityCompany',
        component: CityCompany
      },{
        path: '/index/operationTraining',
        component: OperationTraining
      },{
        path: '/index/returnRecharge',
        component: ReturnRecharge
      },{
        path: '/index/addedService',
        component: AddedService
      },{
        path: '/index/articleList/:id',
        component: ArticleList
      }
    ]
  }, {
    path: '/dashboard',
    redirect: '/dashboard/board',
    component: Dashboard,
    children: [
      {
        path: '/dashboard/board',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Board
      },{
        path: '/dashboard/accountManagement/personalInfo',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: AccountManagement
      },{
        path: '/dashboard/accountManagement/personalInfo',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: PersonalInfo
      },{
        path: '/dashboard/accountManagement/notice',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Notice
      },{
        path: '/dashboard/accountManagement/authenctionCenter',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: AuthenctionCenter
      },{
        path: '/dashboard/accountManagement/authenctionCenter/detail',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: AuthenctionCenterDetail
      },{
        path: '/dashboard/accountManagement/changePassword',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: ChangePassword
      },{
        path: '/dashboard/caiwuManagement/recharge',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: CaiwuManagement
      },{
        path: '/dashboard/caiwuManagement/recharge',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Recharge
      },{
        path: '/dashboard/caiwuManagement/deposit',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Deposit
      },{
        path: '/dashboard/caiwuManagement/record',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Record
      },{
        path: '/dashboard/optimizeManagement',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: OptimizeManagement
      },{
        path: '/dashboard/optimizeManagement/integrationOptimize',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: OptimizeManagement
      },{
        path: '/dashboard/optimizeManagement/integrationOptimize',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: IntegrationOptimize
      },{
        path: '/dashboard/optimizeManagement/integrationOptimizeResult',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: IntegrationOptimizeResult
      },{
        path: '/dashboard/optimizeManagement/quickRanking',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: QuickRanking
      },{
        path: '/dashboard/optimizeManagement/quickRankingDetail',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: QuickRankingDetail
      },{
        path: '/dashboard/optimizeManagement/quickRankingNoData',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: QuickRankingNoData
      },{
        path: '/dashboard/optimizeManagement/SEOOptimize/:id?',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: SEOOptimize
      },{
        path: '/dashboard/optimizeManagement/SEOOptimizeDetail/:id?',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: SEOOptimizeDetail
      },{
        path: '/dashboard/optimizeManagement/webOptimize',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: WebOptimize
      },{
        path: '/dashboard/optimizeManagement/keywordManagement',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: KeywordManagement
      },{
        path: '/dashboard/optimizeManagement/keywordManagementDetail',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: keywordManagementDetail
      },{
        path: '/dashboard/optimizeManagement/shoppingCar',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: ShoppingCar
      },{
        path: '/dashboard/orderManagement',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: OrderManagement
      },{
        path: '/dashboard/orderManagement/detail/id/:id',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: OrderManagementDetail
      },{
        path: '/dashboard/orderManagement/submitOrder',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: SubmitOrder
      },{
        path: '/dashboard/addService',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: AddService
      },{
        path: '/dashboard/apply',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Apply
      },{
        path: '/dashboard/reward',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Reward
      },{
        path: '/dashboard/exit',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Exit
      }, {
        path: '/dashboard/previewVideo',
        meta: {
          needShow: true, // 是否展示左边导航栏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: PreviewVideo
      }
    ]
  }, {
    path: '/test',
    component: G2Circle
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js